import { render } from "./ManageSidebar.vue?vue&type=template&id=10f738b4&scoped=true"
import script from "./ManageSidebar.vue?vue&type=script&lang=js"
export * from "./ManageSidebar.vue?vue&type=script&lang=js"

import "./ManageSidebar.vue?vue&type=style&index=0&id=10f738b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f738b4"]])

export default __exports__